import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PARAMS } from 'src/app/core/common/constants/routes.constant';
import { AvailableSolutionsComponent } from './available-solutions/available-solutions.component';
import { InputSolutionsComponent } from './input-solutions/input-solutions.component';

@Component({
  selector: 'app-select-solutions-container',
  imports: [InputSolutionsComponent, AvailableSolutionsComponent],
  templateUrl: './select-solutions-container.component.html',
  styleUrl: './select-solutions-container.component.scss',
})
export class SelectSolutionsContainerComponent implements OnInit {
  readonly #activeRoute = inject(ActivatedRoute);
  sessionId = '';

  ngOnInit(): void {
    this.#activeRoute.paramMap.subscribe((params) => {
      this.sessionId = params.get(PARAMS.SessionId)!;
    });
  }
}
